import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { take, switchMap } from 'rxjs/operators';
import { combineLatest } from 'rxjs';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ProviderOrganizationsService } from 'src/app/services/provider.organizations.service';
import { UsersService } from 'src/app/services/users.service';
import { ORGANIZATION_ID_CLAIM } from 'src/app/models/user/user.model';
import { Role } from 'src/app/models/user/role.model';

@Component({
  selector: 'app-organization-route-resolver',
  template: '',
  standalone: true
})
export class OrganizationRouteResolverComponent implements OnInit {
  
  constructor(
    private router: Router,
    private authService: AuthenticationService,
    private userService: UsersService,
    private providerOrgService: ProviderOrganizationsService
  ) {}

  ngOnInit(): void {
    combineLatest([
      this.authService.user$,
      this.userService.userRole$
    ]).pipe(
      take(1),
      switchMap(([user, role]) => {
        const organizationId = user?.[ORGANIZATION_ID_CLAIM];
        
        if (role === Role.Consultant) {
          setTimeout(() => {
            this.router.navigate(['/provider/organization-list'], { replaceUrl: true });
          }, 0);
          return [];
        }

        if (!organizationId) {
          setTimeout(() => {
            this.router.navigate(['/provider/dashboard'], { replaceUrl: true });
          },0);
          return [];
        }

        return this.providerOrgService.isParentOrganization(organizationId);
      })
    ).subscribe(isParent => {
      if (isParent !== undefined) {
        if (isParent) {
          this.router.navigate(['/provider/organization-list'], { replaceUrl: true });
        } else {
          this.router.navigate(['/provider/organization'], { replaceUrl: true });
        }
      }
    });
  }
}